import { render, staticRenderFns } from "./u-layout.vue?vue&type=template&id=2ae9c899&functional=true&"
import script from "./u-layout.vue?vue&type=script&lang=js&"
export * from "./u-layout.vue?vue&type=script&lang=js&"
import style0 from "./u-layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports